import { cloneDeep } from 'lodash';

export enum SmartComponentType {
    /**时间轴 */
    TIME_AXIS = 1,
    /**流程 */
    FLOW = 2,
    /**金字塔 */
    PYRAMID = 3,
    /**脑图 */
    MIND_MAP = 4,
    /**树状图 */
    TREE_MAP = 5,
    /**漏斗 */
    Funnel = 6,
    /**SWOT分析图 */
    SWOT = 7,
    /**象限 */
    QUADRANT = 8,
    /**雷达图 */
    RADAR = 9,
    /**对比图 */
    COMPARE = 10,
    /**坐标轴 */
    COORDINATE = 11,
    /**增长曲线 */
    GROWTH_CURVE = 12,
    /**S型 */
    S_CURVE = 13,
    /**齿轮图 */
    GEAR = 14,
    /**泳道图 */
    SWIM_LANE = 15,
    /**鱼骨图 */
    FISH_BONE = 16,
    /**图表 */
    TABLE = 17,
    /**环形箭头 */
    CIRCLE_ARROW = 18,
    /** 关键数据 */
    KEY_DATA = 19,
}
export const SmartComponentTypeOptions = [
    { label: '时间轴', value: SmartComponentType.TIME_AXIS },
    { label: '流程', value: SmartComponentType.FLOW },
    { label: '金字塔', value: SmartComponentType.PYRAMID },
    { label: '脑图', value: SmartComponentType.MIND_MAP },
    { label: '树状图', value: SmartComponentType.TREE_MAP },
    { label: '漏斗', value: SmartComponentType.Funnel },
    { label: 'SWOT分析图', value: SmartComponentType.SWOT },
    { label: '象限', value: SmartComponentType.QUADRANT },
    { label: '雷达图', value: SmartComponentType.RADAR },
    { label: '对比图', value: SmartComponentType.COMPARE },
    { label: '坐标轴', value: SmartComponentType.COORDINATE },
    { label: '增长曲线', value: SmartComponentType.GROWTH_CURVE },
    { label: 'S型', value: SmartComponentType.S_CURVE },
    { label: '齿轮图', value: SmartComponentType.GEAR },
    { label: '泳道图', value: SmartComponentType.SWIM_LANE },
    { label: '鱼骨图', value: SmartComponentType.FISH_BONE },
    { label: '图表', value: SmartComponentType.TABLE },
    { label: '环形箭头', value: SmartComponentType.CIRCLE_ARROW },
    { label: '关键数据', value: SmartComponentType.KEY_DATA },
];

const SmartComponentTypeMap = {
    [SmartComponentType.TIME_AXIS]: [
        { name: '组件标题', isSelect: false },
        { name: '节点时间', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.FLOW]: [
        { name: '组件标题', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.PYRAMID]: [
        { name: '组件标题', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.MIND_MAP]: [
        { name: '组件标题', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.TREE_MAP]: [
        { name: '组件标题', isSelect: false },
        { name: '父节点标题', isSelect: false },
        { name: '子节点标题', isSelect: false },
    ],
    [SmartComponentType.SWOT]: [
        { name: '组件标题', isSelect: false },
        { name: 'S标题', isSelect: false },
        { name: 'S内容', isSelect: false },
        { name: 'W标题', isSelect: false },
        { name: 'W内容', isSelect: false },
        { name: 'O标题', isSelect: false },
        { name: 'O内容', isSelect: false },
        { name: 'T标题', isSelect: false },
        { name: 'T内容', isSelect: false },
    ],
    [SmartComponentType.QUADRANT]: [
        { name: '组件标题', isSelect: false },
        { name: 'x轴左标题', isSelect: false },
        { name: 'x轴右标题', isSelect: false },
        { name: 'y轴上标题', isSelect: false },
        { name: 'y轴下标题', isSelect: false },
        { name: '第一象限标题', isSelect: false },
        { name: '第一象限内容', isSelect: false },
        { name: '第二象限标题', isSelect: false },
        { name: '第二象限内容', isSelect: false },
        { name: '第三象限标题', isSelect: false },
        { name: '第三象限内容', isSelect: false },
        { name: '第四象限标题', isSelect: false },
        { name: '第四象限内容', isSelect: false },
    ],
    [SmartComponentType.SWIM_LANE]: [
        { name: '组件标题', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.FISH_BONE]: [
        { name: '组件标题', isSelect: false },
        { name: '鱼头标题', isSelect: false },
        { name: '鱼头内容', isSelect: false },
        { name: '鱼身标题', isSelect: false },
        { name: '鱼身内容', isSelect: false },
    ],
    [SmartComponentType.COMPARE]: [
        { name: '组件标题', isSelect: false },
        { name: 'A项目标题', isSelect: false },
        { name: 'B项目标题', isSelect: false },
        { name: 'A关键词', isSelect: false },
        { name: 'B关键词', isSelect: false },
    ],
    [SmartComponentType.CIRCLE_ARROW]: [
        { name: '组件标题', isSelect: false },
        { name: '节点标题', isSelect: false },
        { name: '节点内容', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
    [SmartComponentType.KEY_DATA]: [
        { name: '组件标题', isSelect: false },
        { name: '数据', isSelect: false },
        { name: '关键词', isSelect: false },
    ],
} as Record<string, { name: string; isSelect: boolean }[]>;

export const pageTagList = [
    {
        name: '页面类型',
        list: [
            {
                name: '封面',
                isSelect: false,
            },
            {
                name: '目录',
                isSelect: false,
            },
            {
                name: '章节',
                isSelect: false,
            },
            {
                name: '内容',
                isSelect: false,
            },
            {
                name: '主题模板',
                isSelect: false,
            },
            {
                name: '致谢',
                isSelect: false,
            },
            {
                name: '其他',
                isSelect: false,
            },
        ],
    },
    {
        name: '色调',
        list: [
            {
                name: '浅色调',
                isSelect: false,
            },
            {
                name: '深色调',
                isSelect: false,
            },
        ],
    },
    {
        name: '布局',
        list: [
            {
                name: '左',
                isSelect: false,
            },
            {
                name: '中',
                isSelect: false,
            },
            {
                name: '右',
                isSelect: false,
            },
        ],
    },
];

export const svgLayerTagList = [
    {
        name: '主题色',
        list: [
            {
                name: '主题色1',
                isSelect: false,
            },
            {
                name: '次中性色1',
                isSelect: false,
            },
            {
                name: '中性色1',
                isSelect: false,
            },

            {
                name: '主题色2',
                isSelect: false,
            },
            {
                name: '次中性色2',
                isSelect: false,
            },
            {
                name: '中性色2',
                isSelect: false,
            },
            {
                name: '主题色3',
                isSelect: false,
            },
            {
                name: '次中性色3',
                isSelect: false,
            },
            {
                name: '中性色3',
                isSelect: false,
            },
            {
                name: '主题色4',
                isSelect: false,
            },
            {
                name: '次中性色4',
                isSelect: false,
            },
            {
                name: '中性色4',
                isSelect: false,
            },
            {
                name: '主题色5',
                isSelect: false,
            },
            {
                name: '次中性色5',
                isSelect: false,
            },
            {
                name: '中性色5',
                isSelect: false,
            },
            {
                name: '主题色6',
                isSelect: false,
            },
            {
                name: '次中性色6',
                isSelect: false,
            },
            {
                name: '中性色6',
                isSelect: false,
            },
        ],
    },
    {
        name: '可拓展',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
    {
        name: '填充渐变',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
    {
        name: '描边色',
        list: [
            {
                name: '主题色1',
                isSelect: false,
            },
            {
                name: '次中性色1',
                isSelect: false,
            },
            {
                name: '中性色1',
                isSelect: false,
            },

            {
                name: '主题色2',
                isSelect: false,
            },
            {
                name: '次中性色2',
                isSelect: false,
            },
            {
                name: '中性色2',
                isSelect: false,
            },
            {
                name: '主题色3',
                isSelect: false,
            },
            {
                name: '次中性色3',
                isSelect: false,
            },
            {
                name: '中性色3',
                isSelect: false,
            },
            {
                name: '主题色4',
                isSelect: false,
            },
            {
                name: '次中性色4',
                isSelect: false,
            },
            {
                name: '中性色4',
                isSelect: false,
            },
            {
                name: '主题色5',
                isSelect: false,
            },
            {
                name: '次中性色5',
                isSelect: false,
            },
            {
                name: '中性色5',
                isSelect: false,
            },
            {
                name: '主题色6',
                isSelect: false,
            },
            {
                name: '次中性色6',
                isSelect: false,
            },
            {
                name: '中性色6',
                isSelect: false,
            },
        ],
    },
    {
        name: '描边渐变',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
];

export const imgLayerTagList = [
    {
        name: '可替换图片',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
    {
        name: '序号',
        list: [
            {
                name: '1',
                isSelect: false,
            },
            {
                name: '2',
                isSelect: false,
            },
            {
                name: '3',
                isSelect: false,
            },
            {
                name: '4',
                isSelect: false,
            },
            {
                name: '5',
                isSelect: false,
            },
            {
                name: '6',
                isSelect: false,
            },
            {
                name: '7',
                isSelect: false,
            },
            {
                name: '8',
                isSelect: false,
            },
            {
                name: '9',
                isSelect: false,
            },
            {
                name: '10',
                isSelect: false,
            },
        ],
    },
];

export const groupLayerTagList = [
    {
        name: '是否可移动',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
];

export const textLayerTagList = [
    {
        name: '主题色',
        list: [
            {
                name: '主题色1',
                isSelect: false,
            },
            {
                name: '次中性色1',
                isSelect: false,
            },
            {
                name: '中性色1',
                isSelect: false,
            },

            {
                name: '主题色2',
                isSelect: false,
            },
            {
                name: '次中性色2',
                isSelect: false,
            },
            {
                name: '中性色2',
                isSelect: false,
            },
            {
                name: '主题色3',
                isSelect: false,
            },
            {
                name: '次中性色3',
                isSelect: false,
            },
            {
                name: '中性色3',
                isSelect: false,
            },
            {
                name: '主题色4',
                isSelect: false,
            },
            {
                name: '次中性色4',
                isSelect: false,
            },
            {
                name: '中性色4',
                isSelect: false,
            },
            {
                name: '主题色5',
                isSelect: false,
            },
            {
                name: '次中性色5',
                isSelect: false,
            },
            {
                name: '中性色5',
                isSelect: false,
            },
            {
                name: '主题色6',
                isSelect: false,
            },
            {
                name: '次中性色6',
                isSelect: false,
            },
            {
                name: '中性色6',
                isSelect: false,
            },
        ],
    },
    {
        name: '类型',
        list: [
            {
                name: '内容标题',
                isSelect: false,
            },
            {
                name: '内容总结',
                isSelect: false,
            },
            {
                name: '列表标题',
                isSelect: false,
            },
            {
                name: '列表内容',
                isSelect: false,
            },
            {
                name: '封面标题',
                isSelect: false,
            },
            {
                name: '封面副标题',
                isSelect: false,
            },
            {
                name: '汇报日期',
                isSelect: false,
            },
            {
                name: '汇报作者',
                isSelect: false,
            },
            {
                name: '目录标题',
                isSelect: false,
            },
            {
                name: '章节标题',
                isSelect: false,
            },
            {
                name: '章节序号',
                isSelect: false,
            },
            {
                name: '关键字',
                isSelect: false,
            },
            {
                name: '矢量图',
                isSelect: false,
            },
            {
                name: '数字',
                isSelect: false,
            },
        ],
    },
    {
        name: '拓展',
        list: [
            {
                name: '纵向',
                isSelect: false,
            },
            {
                name: '横向',
                isSelect: false,
            },
            {
                name: '整体缩放',
                isSelect: false,
            },
        ],
    },
    {
        name: '渐变',
        list: [
            {
                name: '是',
                isSelect: false,
            },
            {
                name: '否',
                isSelect: false,
            },
        ],
    },
    {
        name: '序号',
        list: [
            {
                name: '1',
                isSelect: false,
            },
            {
                name: '2',
                isSelect: false,
            },
            {
                name: '3',
                isSelect: false,
            },
            {
                name: '4',
                isSelect: false,
            },
            {
                name: '5',
                isSelect: false,
            },
            {
                name: '6',
                isSelect: false,
            },
            {
                name: '7',
                isSelect: false,
            },
            {
                name: '8',
                isSelect: false,
            },
            {
                name: '9',
                isSelect: false,
            },
            {
                name: '10',
                isSelect: false,
            },
        ],
    },
];

export const getTextLayerTagList = (componentType?: string) => {
    if (!componentType) {
        return textLayerTagList;
    }
    const typeList = SmartComponentTypeMap[componentType] || [];
    const list = cloneDeep(textLayerTagList);

    list.find((item) => item.name === '类型')!.list = typeList;
    return list;
};
